routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
     .state('home.eventDetail', {
       url: __env.routes.eventDetail,
       template: `<event-detail   sh-ctrl="shCtrl"></event-detail>`
    })

}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/events/event-detail/event-detail.config.js
 **/